@if ((termsAndConditionsDto$ | async); as termsAndConditionsDto) {
  <div class='content'>
    <h1 class='title text-align-center py-sm'>{{ 'shell-app.termsAndConditions.title' | translate }}</h1>
    <div class='body overflow-scroll px'>
      <div class='template text-align-justify' [innerHTML]="termsAndConditionsDto.template | safe : 'html'"></div>
    </div>
    <div class='footer p text-align-center py-lg shadow'>
      <span class='bold'>{{ 'shell-app.termsAndConditions.needLogin' | translate }}</span>
    </div>
  </div>
}


